// extracted by mini-css-extract-plugin
export default {"card":"ComingSoon_card__hXRu4","head":"ComingSoon_head__ooshb","abomination1":"ComingSoon_abomination1__eXaWo"};